import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  /**
   * 매장 정보 조회
   * @param { number } id - 매장 ID
   * @returns { Promise } 매장 정보
   */
  getStore(id) {
    return defaultClient.get(`/aicrm/stores/${id}`)
  },

  /**
   * store_id로 AI CRM store 조회
   * @param { number } storeId - store ID
   * @returns { Promise } AI CRM store 정보
   */
  getStoreByStoreId(storeId) {
    return defaultClient.get(`/aicrm/stores/get_by_store_id/?${qs.stringify({ store_id: storeId })}`)
  },

  /**
   * 매장 리뷰 목록 조회
   * @param { Object } query - 쿼리 파라미터 (store_id 등)
   * @returns { Promise } 리뷰 목록
   */
  getReviews(query) {
    return defaultClient.get(`/aicrm/reviews/?${qs.stringify(query)}`)
  },

  /**
   * 매장 정보 업데이트
   * @param { number } id - 매장 ID
   * @param { Object } data - 업데이트할 데이터
   * @returns { Promise } 업데이트된 매장 정보
   */
  updateStore(id, data) {
    return defaultClient.put(`/aicrm/stores/${id}`, data)
  },

  /**
   * AI CRM 스토어 생성
   * @param { Object } data - 스토어 데이터 (store_id, naverplace_id)
   * @returns { Promise } 생성된 스토어 정보
   */
  createStore(data) {
    return defaultClient.post('/aicrm/stores/', data)
  },

  /**
   * 친구 목록 조회
   * @param { number } storeId - AI CRM 스토어 ID
   * @returns { Promise } 친구 목록
   */
  getFriends(storeId) {
    return defaultClient.get(`/aicrm/friends/?${qs.stringify({ store_id: storeId })}`)
  },

  /**
   * 친구 추가
   * @param { Object } data - 친구 정보 (aicrm_store, phone, name, characteristics)
   * @returns { Promise } 생성된 친구 정보
   */
  createFriend(data) {
    return defaultClient.post('/aicrm/friends/', data)
  },

  /**
   * 리뷰 스크래핑 실행
   * @param { number } storeId - AI CRM 스토어 ID
   * @returns { Promise } 스크래핑 결과
   */
  scrapeReviews(storeId) {
    return defaultClient.post(`/aicrm/stores/${storeId}/scrape_reviews/`)
  },

  /**
   * SMS 내용 목록 조회
   * @param { number } storeId - AI CRM 스토어 ID
   * @returns { Promise } SMS 내용 목록
   */
  getSmsContents(storeId) {
    return defaultClient.get(`/aicrm/sms-contents/?${qs.stringify({ store_id: storeId })}`)
  },

  /**
   * AI SMS 생성
   * @param { number } storeId - AI CRM 스토어 ID
   * @returns { Promise } 생성된 SMS 내용
   */
  generateAiSms(storeId) {
    return defaultClient.get(`/aicrm/stores/${storeId}/generate_ai_sms/`)
  }
} 